import { Link } from 'react-router-dom';
import VideoCard from '@/components/base/VideoCard';
import { videos, featuredVideoIds } from '@/mocks/videos';

export default function FeaturedVideos() {
  const featuredVideos = featuredVideoIds
    .map((id) => videos.find((v) => v.id === id))
    .filter(Boolean) as typeof videos;

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">编辑精选的高分佳作，不可错过</p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}